import { Browser } from '@capacitor/browser';

export const openInBrowser = async (url) => {
  await Browser.open({ url });
};
